import type { IconNames } from '@workramp/ui';
import { Body, Col, Icon, Row } from '@workramp/ui';
import { useTheme } from 'styled-components';

export enum DeepResearchStepStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  COMPLETED = 'completed',
  ERROR = 'error',
}

export type DeepResearchStepProps = {
  slug: string;
  label: string;
  status: DeepResearchStepStatus;
};

export const DeepResearchStep = ({ label, status }: Pick<DeepResearchStepProps, 'label' | 'status'>) => {
  const theme = useTheme();

  const iconColor = {
    [DeepResearchStepStatus.IDLE]: theme.colors.on[600],
    [DeepResearchStepStatus.PENDING]: theme.colors.primary[600],
    [DeepResearchStepStatus.COMPLETED]: theme.colors.primary[600],
    [DeepResearchStepStatus.ERROR]: theme.colors.warning[600],
  };
  const iconMap: Record<DeepResearchStepStatus, IconNames> = {
    [DeepResearchStepStatus.IDLE]: 'pending:regular',
    [DeepResearchStepStatus.PENDING]: 'pending:regular',
    [DeepResearchStepStatus.COMPLETED]: 'check-circle:solid',
    [DeepResearchStepStatus.ERROR]: 'warning:regular',
  };

  return (
    <Row gapX={1}>
      <Col xs="auto">
        <Icon
          name={iconMap[status]}
          color={iconColor[status]}
          animation={status === DeepResearchStepStatus.PENDING ? 'spinning' : undefined}
        />
      </Col>
      <Col xs="auto">
        <Body level="sm">{label}</Body>
      </Col>
    </Row>
  );
};
